var React = require('react');

function MdCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z","fill":"#13a970"}));
}

MdCheckmark.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = MdCheckmark;

MdCheckmark.default = MdCheckmark;
